$(document).ready(function () {
  // slick slider
  if ($(".slick-slider").length) {
    $(".slick-slider").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      //autoplay: false,
      //autoplaySpeed: 2000,
      fade: true,
      arrows: true,
      dots: false,
    });
  }
});
